export default {
  responseCategoryCases: {
    id: 'http_transform_response_category_cases',
    defaultMessage: 'Cases',
  },
}
